/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowQuiltingWorkshopTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowQuiltingWorkshop,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Quilt Together!",
    "Quilting Workshop Awaits!",
    "Create Your Own Quilt!",
  ],
  title: "Quilting Workshop",
  description: "Organize a fun quilting workshop.",
  longDescription:
    "Gather your friends for an engaging quilting workshop! Choose a date, decide on quilt designs, and plan materials needed!",
  emoji: "🧵",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Woodworker,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Quilting Workshop",
          emoji: "🧵",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the quilting workshop?",
          emoji: "📅",
          completeAction: {
            question: "Decide on quilt designs?",
            description: "What designs should we focus on during the workshop?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What designs should we consider?",
                emoji: "🖌",
                completeAction: {
                  question: "Decide on materials needed?",
                  description: "What materials should we gather for quilting?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What materials should we bring?",
                      emoji: "🧶",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Quilt Together!",
    outroDescription:
      "Your quilting workshop plans are set! Enjoy the creativity!",
  },
};
